import styled, { keyframes, css } from 'styled-components';
import { Form } from '@unform/web';
import { TabPanel } from '@chakra-ui/react';

interface ClienteItemParams {
	selected: boolean;
}

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(500px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 10;

  .active {
    opacity: 1;
    visibility: visible;
    right: 0px;
    animation: ${appearFromLeft} 0.5s;

    @media (max-width: 650px) {
      top: 0px;
      animation: ${appearFromTop} 0.5s;
    }
  }

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }
`;

export const Content = styled.div`
  background: #fff;
  position: fixed;
  right: -450px;
  width: 700px;
  height: 100%;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  visibility: hidden;
  opacity: 0;
  border-radius: 3px;
  padding: 0 20px 1.875rem;
  transition: all 0.5s ease-out;
	// border: 2px solid red;

 // 850px
  @media (max-width: 53.125rem) {
    right: 0px;
    // top: 800px;
    width: 100%;
    margin-top: 0px;
  }
	// 479px
  @media (max-width: 29.9375rem) {
		padding: 0 10px 0.9rem;
	}
`;

export const LoadingView = styled.div`
	flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width:  700px;
  height: 100%;
  position: fixed;
	margin-left: -20px;
  background: rgba(0, 0, 0, 0.2);
  z-index: 10000;

  img {
    width: 100px;
    height: 100px;
  }

	@media (max-width: 850px) {
    width: 100%;
  }
	// 479px
  @media (max-width: 29.9375rem) {
		margin-left: -10px;
		margin-bottom: -30px;
	}
`;

export const Header = styled.header`
  padding: 10px 10px 5px;
	// border: 2px solid red;

  h1 {
    font-size: 1.6rem;
    font-weight: 600;
		padding: 0;
		margin: 0;
  };

	h2 {
		font-weight: 500;
		padding: 0;
		margin: 0;
	};

	// 479px
  @media (max-width: 29.9375rem) {
		h1 {
			font-size: 1.2rem;
		};
		h2 {
			font-size: 1rem;
		};
	}
`;

export const TabsView = styled.div`
  display: flex;
  width: 100%;
  height: 90%;
  // border: 2px solid blue;

  .tabs {
    width: 100%;

    .tab-list {
      .tab {
				font-size: 1.2rem;
        font-weight: 600;
				padding: 2px 15px;

				:first-child {
					padding-left: 2px;
				}

        :focus {
          box-shadow: 0 0 0 0;
          border: 0 0;
        }
      }
    }

    .tab-panels {
      width: 100%;
      height: 93.5%;
      position: relative;
      // border: 2px solid orange;

      .tab-panel {
        width: 100%;
        padding: 0;
      }
    }
  }
`;

export const TabOperacao = styled(TabPanel)`
	display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  div.tab-content {
    display: flex;
    flex-direction: column;
    margin-bottom: 70px;
		width: 100%;
  	height: 100%;
  }
`;

export const TabDocumento = styled(TabPanel)`
	display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  div.tab-content {
    display: flex;
    flex-direction: column;
    margin-bottom: 70px;
		width: 100%;
  	height: 100%;
  }
`;

export const FormView = styled(Form)`
  display: flex;
	flex-direction: column;
  width: 100%;
  // padding: 5px 0;
  margin-bottom: 5px;
	// border: 2px solid orange;

	div.input {
		display: flex;
		flex-direction: column;
		width: 100%;
		margin-top: 10px;
		// border: 1px solid green;

		p {
			font-size: 1rem;
			font-weight: 500;
			margin: 0 0 0 2px;
			padding-bottom: 3px;
			// border: 1px solid red;

			span {
				font-size: 0.8rem;
				color: #455a64;
			}
		}
	}

	.radio-group {
		display: flex;
		// flex-direction: column;
		width: 100%;
		padding: 5px 10px;
		// margin-right: 10px;
		border: 1px solid #d1d2dc;
		border-radius: 8px;
		
		.radio-label {
			display: flex;
			align-items: center;
			margin: 0;

			input[type='radio'] {
				margin-right: 0.2rem; // 10px;
				appearance: none;
				font: inherit;
				color: var(--azul-razio);
				width: 1.125rem; // 18px;
				height: 1.125rem; // 18px;
				border: 2px solid var(--gray-border-lw);
				border-radius: 50%;

				:checked {
					border: 5px solid var(--azul-razio);
				}
			}

			label {
				font-size: 0.9375rem; // 15px
				font-weight: 500;
				color: #455a64;
				margin-right: 100px;
			}
		};
	};

	button {
    font-weight: 600;
    border-radius: 7px;
    padding: 5px 10px;
    margin: 5px 10px 0;
  }

  .button-cancel {
    background-color: transparent;
    color: var(--red-razio);
    border: 1px solid var(--red-razio);
  }
  .button-save {
    background-color: var(--azul-razio);
    color: #fff;
    border: 1px solid var(--azul-razio);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

	// 479px
  @media (max-width: 29.9375rem) {
		button {
			font-size: 13px;
			padding: 7px 10px;
			margin: 5px 10px 0;
		}
	}
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between; // flex-end;
  align-items: center;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 700px;
	// visibility: hidden;

	.buttons {
		button {
			font-weight: 600;
			border-radius: 7px;
			padding: 10px 20px;
			margin: 5px 10px;
		}

		.button-cancel {
			background-color: transparent;
			color: var(--red-razio);
			border: 1px solid var(--red-razio);
		}
		.button-save {
			background-color: var(--azul-razio);
			color: #fff;
			border: 1px solid var(--azul-razio);

			&:disabled {
				opacity: 0.6;
				cursor: not-allowed;
			}
		}
	}

	// 850px
	@media (max-width: 53.125rem) {
    width: 100%;
  }
	// 479px
  @media (max-width: 29.9375rem) {
		button {
			:first-child {
				margin-right: 0px;
			}

			margin-left: 0px;
		}
	}
`;

export const TabCliente = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
	// border: 2px solid blue;

	button {
		font-weight: 600;
		border-radius: 7px;
		padding: 5px 10px;
		margin: 5px 10px;
	}
	.button-save {
		background-color: var(--azul-razio);
		color: #fff;
		border: 1px solid var(--azul-razio);

		&:disabled {
			opacity: 0.6;
			cursor: not-allowed;
		}
	}

  div.tab-content {
    display: flex;
    flex-direction: column;
    margin-bottom: 70px;
		width: 100%;
  	height: 100%;
		// border: 2px solid red;
  }

	// 479px
  @media (max-width: 29.9375rem) {
		button {
			font-size: 13px;
			padding: 7px 10px;
			margin: 5px 10px 0;
		}
	}
`;

export const ClienteItem = styled.div<ClienteItemParams>`
	display: flex;
	flex-direction: column;
	padding: 2px 8px;
	margin: 10px;
	border: 2px solid #d1d2dc;
	border-radius: 8px;

	h2 {
		font-size: 14px;
		font-weight: 500;
		color: #455a64;
	}
	span {
		color: #333
	}
	svg {
		font-size: 30px;
		color: #2196f3;
		margin-right: 5px;
	}

	${props =>
		props.selected &&
		css`
      background: #2196f3;
      border-color: #2196f3;

			h2 {
				color: #d1d2dc;
			}
			span {
				color: #fff;
			}

			svg {
				color: #fff
			}
    `}

	// 479px
  @media (max-width: 29.9375rem) {
		h2 {
			font-size: 14px;
		}
		span {
			font-size: 13px;
		}
		svg {
			font-size: 25px;
	}
	}
`;

export const TabConta = styled(TabPanel)`
	display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
	// border: 2px solid blue;

  div.tab-content {
    display: flex;
    flex-direction: column;
    margin-bottom: 70px;
		width: 100%;
  	height: 100%;
		// border: 2px solid red;
  }

	// 479px
  @media (max-width: 29.9375rem) {
		button {
			font-size: 13px;
			padding: 7px 10px;
			margin: 5px 10px 0;
		}
	}
`;

export const TabLancamento = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  div.tab-content {
    display: flex;
    flex-direction: column;
    margin-bottom: 150px;
		padding-bottom: 150px;
		width: 100%;
  	height: 100%;
  }

	// 479px
  @media (max-width: 29.9375rem) {
		button {
			font-size: 13px;
			padding: 7px 10px;
			margin: 5px 10px 0;
		}
	}
`;
